import { useCallback } from 'react';

export const useScroll = ({ onScrollUp, onScrollDown }) => {
    const listeners = {
        onWheel: useCallback(
            (e) => {
                // e.preventDefault(); // Prevent page scroll (optional)
                if (e.deltaY < 0) {
                    onScrollUp?.(e); // Scroll up
                } else {
                    onScrollDown?.(e); // Scroll down
                }
            },
            [onScrollUp, onScrollDown],
        ),
    };

    return { listeners };
};
